import type { VoidFunctionComponent } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { icons, TextInput } from '../../../../../generic';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../../../generic/Button';
import * as ReportGenerationStore from '../../../../../../redux/reportGeneration';
import styles from '../SidePanel.module.less';
import type { ReportButtonBaseProps } from './types';

type PublicLinkButtonProps = ReportButtonBaseProps & {
  isDisabled?: boolean;
};

/**
 * Provides public link functionality for the distribution panel.
 * This allows a user to generate and view a public report url
 */
const PublicLinkButton: VoidFunctionComponent<PublicLinkButtonProps & { isDisabled?: boolean }> = ({
  reportContext,
  reportOptions,
  isDisabled,
}) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector(ReportGenerationStore.selectors.getFetchPublicReportUrlStatus);
  const reportURL = useSelector(ReportGenerationStore.selectors.getPublicReportUrl);

  // Reset report url when context shifts
  useEffect(() => {
    dispatch(ReportGenerationStore.actions.resetState());
  }, [dispatch, reportContext, reportOptions]);

  const generatePublicURL = () =>
    dispatch(ReportGenerationStore.actions.fetchPublicReportURL(reportContext, reportOptions));

  return (
    <div className={cx(styles.actionButton, styles.publicReport)}>
      <TextInput
        label="Report URL"
        size="small"
        value={reportURL || 'Click for public link -->'}
        isDisabled={!reportURL || isDisabled}
        onChange={() => false}
      />
      <Button
        icon={icons.refresh}
        type={BUTTON_TYPE.SECONDARY}
        size={BUTTON_SIZE.MEDIUM}
        iconHasSpin={isLoading}
        isDisabled={isLoading || isDisabled}
        onClick={generatePublicURL}
      />
    </div>
  );
};

export default PublicLinkButton;
